import type { Theme } from "react-select";

/** Thème react-select partagé (primary sky) pour les selects métier. */
export const reactSelectTheme = (theme: Theme): Theme => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary: "rgb(14 165 233)",
  },
});
